interface EZFileLogoProps {
  width?: number;
  flat?: boolean;
}
const EZFileLogo = ({ width = 124, flat = false }: EZFileLogoProps) => {
  const aspectRatio = 5.167;
  const fill = flat ? '#FEFEFA' : '#3C9571';
  return (
    <svg
      width={width}
      height={Math.ceil(width / aspectRatio)}
      viewBox="0 0 124 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.17736 15.2212H20.9406V9.08594H9.17736V7.16557H23.1209V0.282155H0.27887L0 24H25.8464V17.1415H9.17736V15.2212Z"
        fill={fill}
      />
      <path
        d="M39.0001 17.1415L50.9555 7.16557L50.9555 0.282155H28.1135V7.16557L39.7637 7.12774L27.8346 17.1415V24H51.0062V17.1415L39.0001 17.1415Z"
        fill={fill}
      />
      <path
        d="M59.0295 0.452795C59.0295 0.150932 59.161 0 59.424 0H73.8897C74.1089 0 74.2185 0.11859 74.2185 0.355769V2.00524C74.2185 2.26398 74.076 2.39335 73.7911 2.39335H62.613C62.3281 2.39335 62.1856 2.52272 62.1856 2.78146V10.7377C62.1856 10.9749 62.3062 11.0935 62.5473 11.0935H71.3254C71.5665 11.0935 71.687 11.2013 71.687 11.4169V13.1311C71.687 13.3251 71.5665 13.4221 71.3254 13.4221H62.5473C62.3062 13.4221 62.1856 13.5407 62.1856 13.7779V23.5777C62.1856 23.858 62.0322 23.9981 61.7254 23.9981H59.4898C59.3144 23.9981 59.1939 23.9658 59.1281 23.9011C59.0624 23.8364 59.0295 23.7178 59.0295 23.5454V0.452795Z"
        fill="#FEFEFA"
      />
      <path
        d="M81.5364 0C81.7994 0 81.9309 0.140151 81.9309 0.420453V23.4483C81.9309 23.6639 81.8871 23.8149 81.7994 23.9011C81.7118 23.9658 81.5583 23.9981 81.3391 23.9981H79.2679C79.0706 23.9981 78.9391 23.9658 78.8734 23.9011C78.8076 23.8364 78.7748 23.7178 78.7748 23.5454V0.452795C78.7748 0.150932 78.9063 0 79.1693 0H81.5364Z"
        fill="#FEFEFA"
      />
      <path
        d="M88.3103 0.452795C88.3103 0.150932 88.4418 0 88.7048 0H91.0719C91.335 0 91.4665 0.140151 91.4665 0.420453V21.2814C91.4665 21.497 91.576 21.6048 91.7952 21.6048H103.171C103.434 21.6048 103.565 21.7126 103.565 21.9282V23.6424C103.565 23.7502 103.532 23.8364 103.466 23.9011C103.401 23.9658 103.302 23.9981 103.171 23.9981H88.7706C88.5952 23.9981 88.4747 23.9658 88.4089 23.9011C88.3432 23.8149 88.3103 23.6963 88.3103 23.5454V0.452795Z"
        fill="#FEFEFA"
      />
      <path
        d="M108.088 0.452795C108.088 0.150932 108.219 0 108.482 0H123.244C123.463 0 123.573 0.11859 123.573 0.355769V2.00524C123.573 2.26398 123.43 2.39335 123.145 2.39335H111.671C111.386 2.39335 111.244 2.52272 111.244 2.78146V10.3496C111.244 10.5868 111.364 10.7054 111.605 10.7054H120.121C120.362 10.7054 120.482 10.824 120.482 11.0611V12.7753C120.482 12.8615 120.46 12.937 120.416 13.0017C120.373 13.0448 120.274 13.0664 120.121 13.0664H111.605C111.364 13.0664 111.244 13.185 111.244 13.4221V21.2814C111.244 21.497 111.353 21.6048 111.573 21.6048H123.638C123.879 21.6048 124 21.7126 124 21.9282V23.6424C124 23.7502 123.967 23.8364 123.901 23.9011C123.858 23.9658 123.77 23.9981 123.638 23.9981H108.548C108.241 23.9981 108.088 23.8472 108.088 23.5454V0.452795Z"
        fill="#FEFEFA"
      />
    </svg>
  );
};

export default EZFileLogo;
